import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface SeoPauseState {
  enabled: boolean;
  reason: string | null;
  loading: boolean;
}

let cached: { enabled: boolean; reason: string | null } | null = null;
let inflight: Promise<void> | null = null;

export function useSeoPause(): SeoPauseState {
  const [state, setState] = useState<SeoPauseState>({
    enabled: cached?.enabled ?? false,
    reason: cached?.reason ?? null,
    loading: cached === null,
  });

  useEffect(() => {
    if (cached !== null) return;
    if (!inflight) {
      inflight = (async () => {
        try {
          const { data, error } = await supabase.functions.invoke("get-seo-pause-status");
          if (error) throw error;
          cached = { enabled: !!data?.enabled, reason: data?.reason ?? null };
        } catch {
          cached = { enabled: false, reason: null };
        } finally {
          inflight = null;
        }
      })();
    }
    inflight.then(() => {
      if (cached) setState({ ...cached, loading: false });
      else setState((p) => ({ ...p, loading: false }));
    });
  }, []);

  return state;
}

export function clearSeoPauseCache() {
  cached = null;
}
